import servise from '@/router/axios'

//获取表格
export const getReportRule = (params)=>{
    return servise({
        url:"/reportRule/list",
        params
    })
}
//下载规则报表
export const getReportXlsx = (params)=>{
    return process.env.VUE_APP_BASE_API  + '/reportRule/list/xlsx?' + qs.stringify(params)
}